import type { SWRConfigInterface } from "@gik/core/api/BaseAPIConfig";
import { wpAcfV3Api } from "@gik/core/api/ky/wpApi";
import { useWPAcfV3Api } from "@gik/core/api/swr/useWPAcfV3Api";
import type { WordpressFAQItem } from "@gik/core/models/wordpress/WordpressFAQItem";

const path = "options/options/faq";

export interface IFaqResponse {
	faq: WordpressFAQItem[];
}

export function getFaq() {
	return wpAcfV3Api.get(path).json<IFaqResponse>();
}

export function useFaq(config?: SWRConfigInterface) {
	return useWPAcfV3Api<IFaqResponse>(path, null, config);
}
